import type { ChatFeedback as Feedback } from '../chat-feedback.js';
import { Markdown } from './Markdown.js';

export function ChatFeedback({ value }: { value: Feedback | null }) {
  if (!value) return null;
  return <div className="a3-chat-feedback">
    <div className="a3-chat-feedback-status" role="status" aria-live="polite" aria-atomic="true">
      {value.active && <span className="a3-inline-typing" aria-hidden="true"><span><i /><i /><i /></span></span>}
      <span>{value.label}</span>
    </div>
    {value.details.length > 0 && <details className="a3-chat-feedback-details"><summary>View activity</summary>
      {value.details.map((detail, index) => <Markdown key={index}>{detail}</Markdown>)}
    </details>}
  </div>;
}
